/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseThumbsDownCheckData } from './genericApiResponseThumbsDownCheckData';
import type { GenericApiResponseThumbsDownCheckMessage } from './genericApiResponseThumbsDownCheckMessage';
import type { GenericApiResponseThumbsDownCheckPagination } from './genericApiResponseThumbsDownCheckPagination';
import type { GenericApiResponseThumbsDownCheckError } from './genericApiResponseThumbsDownCheckError';

export interface GenericApiResponseThumbsDownCheck {
  data?: GenericApiResponseThumbsDownCheckData;
  message?: GenericApiResponseThumbsDownCheckMessage;
  pagination?: GenericApiResponseThumbsDownCheckPagination;
  error?: GenericApiResponseThumbsDownCheckError;
  statusCode?: number;
}
